import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class I18nService {
  private tokenService = inject(TokenService);
  private translate = inject(TranslateService);

  initializeLanguageFromOriginCookie(): void {
    const origin = this.tokenService.getCookie('edutin_origin');
    this.applyLanguageFromOrigin(origin);
  }

  applyLanguageFromOrigin(origin: string | null): void {
    const initialLang = this.getInitialLanguageFromOrigin(origin);

    this.translate.setDefaultLang('es');
    this.translate.use(initialLang);
  }

  private getInitialLanguageFromOrigin(origin: string | null): 'es' | 'pt' {
    return origin?.trim().toLowerCase() === 'br' ? 'pt' : 'es';
  }
}
